export { PriceDisplay, DiscountPriceDisplay, FromPriceDisplay } from './PriceDisplay';
export type {
  PriceDisplayProps,
  DiscountPriceDisplayProps,
  FromPriceDisplayProps,
  PriceObject,
  DiscountObject,
} from './PriceDisplay.types';
